export default "__VITE_ASSET__D4$eIg36__"